<!--
  Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->

<p-card [header]="header" [subheader]="subheader" [style]="{ width: 'auto' }">
    <p-fileUpload #fileUpload chooseLabel="{{chooseLabel}}" [accept]="accept"
                  [showCancelButton]="showCancelButton" [showUploadButton]="false" [multiple]="multiple"
                  cancelLabel="Clear Files" (onClear)="fileUpload.clear(); onFileSelect()"
                  (onSelect)="onFileSelect()">
        <ng-template pTemplate="empty">
            <div class="dragAndDropTag">{{placeholder}}</div>
        </ng-template>
        <ng-template let-file pTemplate="file">
            <div class="flex items-center">
                <div class="w-auto">{{file.name}}</div>
                <div class="w-auto file-size">{{formatFileSize(file.size)}} KB</div>
                <div class="w-auto">
                    <button pButton size="small" pRipple type="button"
                            class="p-button-rounded p-button-text"
                            (click)="fileUpload.remove($event, fileUpload.files.indexOf(file)); onFileSelect();"><i class="pi pi-times" pButtonIcon></i></button>
                </div>
            </div>
        </ng-template>
    </p-fileUpload>
</p-card>
